"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var isArrayLike_1 = require("../../utils/isArrayLike");
var AggregateTransform = /** @class */ (function (_super) {
    __extends(AggregateTransform, _super);
    function AggregateTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AggregateTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        var aggregateTransformOptions = this.options.aggregateTransformOptions;
        if (queryResponse && isArrayLike_1.isArrayLike(queryResponse)) {
            var _a = aggregateTransformOptions.type, type = _a === void 0 ? 'sum' : _a, key_1 = aggregateTransformOptions.key;
            var values = key_1 ? queryResponse.map(function (i) { return i[key_1]; }) : queryResponse;
            var total = values.reduce(function (acc, value) {
                return acc + value;
            }, 0);
            var count = values.length;
            if (type === 'sum') {
                response = total;
            }
            if (type === 'count') {
                response = count;
            }
            if (type === 'average') {
                response = count > 0 ? total / count : 0;
            }
        }
        return response;
    };
    return AggregateTransform;
}(BaseTransform_1.BaseTransform));
exports.AggregateTransform = AggregateTransform;
//# sourceMappingURL=AggregateTransform.js.map